import settings from "../../../../constants/settings";
import { useCustomConfirm, useCustomAlert } from "../../alerts";
import useFetchAndTrace from "../../fetchWithTrace";

export const useDeleteBoard = (onDelete?: () => void) => {
  const fetchAndTrace = useFetchAndTrace();
  const customConfirm = useCustomConfirm();
  const customAlert = useCustomAlert();

  const deletionHandler = async (response: Response) => {
    if (response.ok) {
      if (onDelete !== undefined) {
        onDelete();
      }
    } else if (response.status == 403 || response.status == 401) {
      const { detail: message } = (await response.json()) as { detail: string };
      customAlert(message);
    } else {
      throw Error("Failed to delete board");
    }
  };

  const errorHandler = () => {
    customAlert(
      "Sorry, we failed to delete your board. We will be looking into this.",
    );
  };

  return (boardId: string) =>
    customConfirm(
      "Deleting a board will erase all associated data and cannot be undone. Are you sure you want to delete this board?",
      async () => {
        await fetchAndTrace(
          `${settings.api_url}/boards/${boardId}`,
          deletionHandler,
          errorHandler,
          {
            method: "DELETE",
          },
        );
      },
    );
};
